import React, { useEffect, useState, useRef } from 'react';
const GHOST_MESSAGES = ["I can't believe you said that", "Why haven't you replied?", 'Should I even send this?', 'What did they actually mean...', 'I just need to say something', 'This is eating me alive', 'How do I even start?', 'Was that passive aggressive?', 'Are they mad at me?', 'Why does this feel off?', 'I keep rereading it', 'Did I overshare again?'];
type Bubble = {
  id: number;
  msg: string;
  x: number;
  duration: number;
  side: 'left' | 'right';
};
const FloatingBubbles = () => {
  const [bubbles, setBubbles] = useState<Bubble[]>([]);
  const nextId = useRef(0);
  useEffect(() => {
    const spawn = () => {
      const id = nextId.current++;
      const msg = GHOST_MESSAGES[Math.floor(Math.random() * GHOST_MESSAGES.length)];
      const x = 8 + Math.random() * 84;
      const duration = 7000 + Math.random() * 5000;
      const side: 'left' | 'right' = Math.random() > 0.5 ? 'right' : 'left';
      setBubbles(b => [...b.slice(-7), {
        id,
        msg,
        x,
        duration,
        side
      }]);
      setTimeout(() => {
        setBubbles(b => b.filter(bb => bb.id !== id));
      }, duration);
    };
    spawn();
    const t = setInterval(spawn, 2200);
    return () => clearInterval(t);
  }, []);
  return <div aria-hidden="true" style={{
    position: 'absolute',
    inset: 0,
    pointerEvents: 'none',
    overflow: 'hidden',
    zIndex: 1
  }} data-id="element-91">
      {bubbles.map(b => <div key={b.id} style={{
      position: 'absolute',
      left: `${b.x}%`,
      bottom: '-60px',
      animation: `bubble-rise ${b.duration}ms cubic-bezier(0.2, 0, 0.8, 1) forwards`,
      opacity: 0,
      maxWidth: 240
    }} data-id="element-92">
          <div style={{
        background: b.side === 'right' ? 'rgba(232, 123, 92, 0.10)' : 'rgba(26, 31, 54, 0.04)',
        backdropFilter: 'blur(12px)',
        WebkitBackdropFilter: 'blur(12px)',
        border: b.side === 'right' ? '1px solid rgba(232, 123, 92, 0.18)' : '1px solid rgba(26, 31, 54, 0.08)',
        borderRadius: b.side === 'right' ? '18px 18px 4px 18px' : '18px 18px 18px 4px',
        padding: '10px 16px',
        fontSize: 13,
        color: b.side === 'right' ? 'rgba(232, 123, 92, 0.75)' : 'rgba(26, 31, 54, 0.45)',
        lineHeight: 1.45,
        whiteSpace: 'nowrap',
        fontFamily: 'Inter, sans-serif'
      }} data-id="element-93">
            {b.msg}
          </div>
        </div>)}
    </div>;
};
export default FloatingBubbles;